import { Modal, Tabs } from "antd";
import React from "react";
import PlanOverview from "../../top-plan/PlanOverview";
import TopPlanKpi from "../../top-plan/TopPlanKpi";
import TopPlanTasks from "../../top-plan/TopPlanTasks";
import PlanWorksheet from "../../top-plan/PlanWorksheet";

const { TabPane } = Tabs;

function SplitPlanInfoModal(props) {
  return (
    <Modal
      title={props.plan?.title}
      visible={props.visible}
      onCancel={() => props.handleCancel()}
      footer={null}
      width={900}
    >
      <Tabs defaultActiveKey="1" centered>
        <TabPane tab={<div className="w-32 text-center">Overview</div>} key="1">
          <div className="px-6">
            <PlanOverview
              data={props.plan}
              updateTarget={(target) => props.updateTarget(target)}
            />
          </div>
        </TabPane>
        {props.plan?.kpi && (
          <TabPane tab={<div className="w-32 text-center">KPIs</div>} key="2">
            <div className="px-6">
              <TopPlanKpi data={props.plan} />
            </div>
          </TabPane>
        )}
        {props.plan?.tasks && (
          <TabPane tab={<div className="w-32 text-center">Tasks</div>} key="3">
            <div className="px-6">
              <TopPlanTasks data={props.plan} />
            </div>
          </TabPane>
        )}
        {props.plan?.worksheet && (
          <TabPane tab={<div className="w-32 text-center">Worksheet</div>} key="4">
            <PlanWorksheet planId={props.plan?.planId} data={props.plan} />
          </TabPane>
        )}
      </Tabs>
    </Modal>
  );
}
export default SplitPlanInfoModal;
